<template>
  <div class="fair-pay-detail-view">
    <PayRangeDetailPage :pay-range-id="resolvedId" />
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router/composables";
import PayRangeDetailPage from "@components/PayRangeDetailPage/PayRangeDetailPage.vue";

const props = defineProps({
  payRangeId: { type: [String, Number], default: null },
});

const route = useRoute();
const resolvedId = computed(() => props.payRangeId || route.params.payRangeId || route.params.id);
</script>

<style scoped>
.fair-pay-detail-view {
  width: 100%;
}
</style>
